import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();

    const linkElement = this.element;

    // Disable the link and update text
    linkElement.classList.add("disabled");
    const originalText = linkElement.innerHTML;
    linkElement.innerHTML = "Finding you...";

    const success = ({ coords }) => {
      // Create the new URL with the coordinates as parameters
      const baseUrl = linkElement.getAttribute("href");
      const separator = baseUrl.includes("?") ? "&" : "?";
      const newUrl = `${baseUrl}${separator}lng=${coords.longitude}&lat=${coords.latitude}`;

      // Navigate to the new URL
      window.location.href = newUrl;
    };

    const error = (geolocationError) => {
      if (geolocationError instanceof GeolocationPositionError) {
        switch (geolocationError.code) {
          case 1:
            alert("You need to allow Orange to access your location");
            break;
        }
      }

      // Reset the link
      linkElement.classList.remove("disabled");
      linkElement.innerHTML = originalText;

      // Continue to the original URL without coordinates
      window.location.href = linkElement.getAttribute("href");
    };

    navigator.geolocation.getCurrentPosition(success, error);
  }
}
